export const DEFAULT_TRANSLATE_PREFIX = '/assets/i18n/';
export const DEFAULT_TRANSLATE_SUFFIX = '.json?';
